import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, Navbar } from "../../components";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../../constants/apiConstants';
import { formatDate, calculateDifference, dateMonthYears } from "./../Utils";

import "../../assets/css/bootstrap.min.css";
import "../../assets/css/fontawesome-all.min.css";
import "../../assets/css/slick.css";
import "../../assets/css/line-awesome.min.css";
import "../../assets/css/main.css";
import "../../assets/css/responsive.css";
import "../../css/Tabss.css"

// Importing assets
import ProfileImage from "../../assets/images/all/Instituteimage.png";
import NotificationIcon from "../../assets/images/icons/notification-bing-svgrepo-com 1.svg";
import whiteImage from "../../assets/images/icons/white+.svg"
import Plus_orange_Vector from '../../assets/images/icons/Plus_orange_Vector.svg'

import SearchIcon from "../../assets/images/all/search.svg";

import CommanInstitute from '../../components/CommanInstitute';
import Group from '../../assets/images/icons/Group 85.svg'
import downArrowImage from '../../assets/images/icons/down-arrow-5-svgrepo-com (2) 4.svg'
import UpImage from '../../assets/images/icons/down-arrow-5-svgrepo-com (2) 3.svg'
import prime_file from '../../assets/images/icons/prime_file-pdf.svg'


const InstituteCurriculum = (props) => {

    const navigate = useNavigate();



    /// Stream end
    // console.log("streamDetailsstreamDetails", managers)
    return (
        <div className="bg_dashboard">

            <div className="container">
                <div className="row">

                    <CommanInstitute />


                    <div class="col-sm-9 col-md-12 col-xl-9 px-md-5 ps-xl-5 ">
                    <div className="row mt-5">
                    <div className="col-md-9 ps-0">
                        <div className="search-box dashboard_search">
                            <input type="text"
                                className="common-input common-input--lg dashboard_search_input pill shadow-sm auto-suggestion-input"
                                placeholder="Search"/>
                            <button type="submit" className="btn btn-main spl_burron  border-0"><img
                                    src={SearchIcon} alt="" /></button>
                        </div>
                    </div>
                    <div className="col-md-2 text-xl-center  mt-3">
                        <img src={NotificationIcon} alt="" />
                    </div>
                    <div className="col-md-1">
                        <div className="dashboard_profile ms-auto">
                            <img src={ProfileImage} alt=""/>
                        </div>
                    </div>
                </div>


             
                <div class="row px-0 py-3">
                    <div class="col-sm-12">

                        <h2 class="learm-tilte">Course Curriculum</h2>
                        <p>Start putting together your course by creating sections, lectures and practice activities
                            (quizzes, coding exercises and assignments).</p>
                        <p>Use your course outline to structure your content and label your sections and lectures
                            clearly. If you're intending to offer your course for free, the total length of video
                            content must be less than 2 hours.</p>
                    </div>
                </div>
                <div class="row p-0">
                    <div class="dashboard_card p-0">
                        
                        <div class="row px-0 px-sm-3 mt-4">
                            <div class="col-sm-12">
                                <div class="dashboard_card px-4 pb-4">
                                    <div class="">
                                        <p><label for="sectionTitle" class="profile_text_2">Section Title</label></p>
                                        <label class="my-2">Lecture 1: Introduction</label>
                                        <div class="position-relative">
                                            <select class="common-input common-input--md dash_borad_input_1"
                                                id="lectureContent">
                                                <option selected disabled>Content</option>
                                                <option value="1">Video</option>
                                                <option value="2">Quiz</option>
                                                <option value="3">Assignment</option>
                                            </select>
                                        </div>
                                    </div>
                                
                                    <button type="button"
                                        class="btn btn-secondary text-white px-4 py-2 d-flex align-items-center mt-3">
                                        <img src={whiteImage} alt="" style={{ marginRight: '8px' }}/>
                                        Curriculum Item
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                 
                    <div class="row px-0 px-sm-3 mt-4">
                        <div class="col-sm-12 text-start">
                            <button type="button"
                                class="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-16">Add New
                                Section</button>
                        </div>
                    </div>
                </div>


               
                <div class="row p-0 mt-5">
                    <div class="dashboard_card p-0">
                        <div class="row px-0 px-sm-3 mt-4">
                            <div class="col-sm-12">
                                <div class="dashboard_card px-4 pb-4">
                                  
                                    <label for="sectionTitle" class="profile_text_2 mb-3">Section Title</label>
                                    <div class="position-relative mb-3">
                                        <input type="text"
                                            class="common-input common-input--md dash_borad_input_1 form-control"
                                            id="sectionTitle" placeholder="Enter a Title" maxlength="100"/>
                                        <span class="character-count position-absolute"
                                            style={{
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                position: 'absolute', // Include this if the element needs positioning
                                              }}>0/100</span>
                                    </div>

                                 
                                    <label for="learningObjective" class="profile_text_2 mb-3">Learning
                                        Objective</label>
                                    <div class="position-relative mb-3">
                                        <input type="text"
                                            class="common-input common-input--md dash_borad_input_1 form-control"
                                            id="learningObjective" placeholder="Enter a Learning Objective"
                                            maxlength="300"/>
                                        <span class="character-count position-absolute"
                                            style={{
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                              }}>0/300</span>
                                    </div>

                                    <div class="text-end">
                                     
                                        <button type="button"
                                            class="btn   py-2 px-4 bg-transparent fw-500 font-16">Cancel</button>
                                        <button type="button"
                                            class="btn btn_cousre bg-main-btn text-white py-2 px-3 fw-500 pill font-16 ms-2">Add
                                            Section</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

             
                <div class="row p-0 mt-4">
                    <div class="dashboard_card p-0">
                        <div class="row px-0 px-sm-3 mt-4">
                            <div class="col-sm-12 text-start">
                                <div class="dashboard_card px-4 pb-4">

                                    <p><label for="sectionTitle" class="profile_text_2">Section Title</label></p>
                                    <button type="button"
                                        class="btn btn-secondary text-white px-4 py-2 d-flex align-items-center justify-content-center mt-3">
                                        <img src={whiteImage} alt="" style={{ marginRight: '8px' }}/>
                                        Curriculum Item
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

               
                <div class="row p-0 mt-4">
                    <div class="dashboard_card p-0">
                        <div class="row px-0 px-sm-3 mt-4">
                            <div class="col-sm-12 text-start">

                                <div class="dashboard_card px-4 pb-4">

                                 

                                 
                                    <label for="sectionTitle" class="profile_text_2">Section 1: Introduction</label>

                                  
                                    <div class="d-flex justify-content-center mt-3">
                                        <button type="button" class="btn me-2" onclick="addItem('Lecture')"><img
                                                src={Plus_orange_Vector} class="me-1" alt=""/>
                                            Lecture</button>
                                        <button type="button" class="btn  me-2" onclick="addItem('Practice')"><img
                                                src={Plus_orange_Vector} class="me-1" alt=""/>
                                            Practice</button>
                                        <button type="button" class="btn" onclick="addItem('Assignment')"><img
                                                src={Plus_orange_Vector} class="me-1" alt=""/>
                                            Assignment</button>
                                    </div>

                                  
                                    <div id="itemBox"
                                        class="common-input common-input--md dash_borad_input_1 item-box form-control mt-3">
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row p-0 mt-4">
                    <div class="dashboard_card p-0">
                        <div class="row px-0 px-sm-3 mt-4">
                            <div class="col-sm-12 text-start">
                                <div class="dashboard_card px-4 pb-4">
                                    <div class="">
                                        <p><label for="sectionTitle" class="profile_text_2">Section Title</label></p>
                                        <label class="my-2">Lecture 1: Introduction</label>
                                        <div class="position-relative">
                                            <select class="common-input common-input--md dash_borad_input_1"
                                                id="lectureContent">
                                                <option selected disabled>Content</option>
                                                <option value="1">Video</option>
                                                <option value="2">Quiz</option>
                                                <option value="3">Assignment</option>
                                            </select>
                                        </div>
                                    </div>
                                  
                                    <button type="button"
                                        class="btn btn-secondary text-white px-4 py-2 d-flex align-items-center mt-3">
                                        <img src={whiteImage} alt="" style={{ marginRight: '8px' }}/>
                                        Curriculum Item
                                    </button>

                                    <div class="d-flex justify-content-end align-items-center mt-2">
                                        <div>
                                            <span class="course-time me-3"><img class="me-2"
                                                    src={Group} alt=""/> Media</span>
                                        </div>
                                        <div>
                                            <span class="course-time"><img class=""
                                                    src={prime_file} alt=""/> PDF</span>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                <div class="row mb-5 mt-3">
                            <div class="col-sm-12 d-flex justify-content-between">
                                <span class="learm-tilte2 font-16" onClick={() => navigate("/CourseStructure")}><img
                                    src={downArrowImage} alt="" /> Previous</span>
                                <span class="learm-tilte2 font-16" onClick={() => navigate("/InstituteCaption")}>Next <img
                                    src={UpImage} alt="" /></span>
                            </div>
                        </div>




            </div>
                </div>

            </div>






            {/* Footer */}
            <Footer />
        </div>
    );
};

export default InstituteCurriculum;






